import { useState } from 'react';
import './IntroHeader.css';
import MHLogo from '../../assets/MHlogo.svg';
import CustomGreenButton from '../../UI/Intro/customButton/customGreenButton';
import Aurora from '../Intro/Aurora/Aurora';
import EmailModal from '../../UI/EmailModal';
import { Snackbar, Alert } from '@mui/material';
import { useContactUsMutation } from '../../store/services/other/other';


const IntroHeader = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');
    const [contactUs] = useContactUsMutation();

    const handleOpen = () => {
        setIsModalOpen(true);
    };
    const handleClose = () => {
        setIsModalOpen(false);
    };
    const handleSnackbarClose = () => {
        setOpenSnackbar(false);
    };
    const handleSendEmail = async (emailData) => {
        try {
            const response = await contactUs(emailData).unwrap();
            if (response.message === 'success') {
                setSnackbarMessage('Email sent successfully!');
                setSnackbarSeverity('success');
            }
        } catch (error) {
            setSnackbarMessage('An error occurred!');
            setSnackbarSeverity('error');
            handleClose();
        }
        setOpenSnackbar(true);
    }
    return (
        <div className='new-header'>
            {/* Aurora background */}
            <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                zIndex: 0, // background
                pointerEvents: 'none', // so it doesn't block clicks
            }}>
                <Aurora
                    colorStops={['#01F5B0', '#FDDE6E', '#28C1F9']}
                    blend={0.5}
                    amplitude={1.0}
                    speed={0.5}
                />
            </div>
            {/* Header content */}
            <div className='header-inner' style={{ position: 'relative', zIndex: 1 }}>
                <div className='logo-left'>
                    <img src={MHLogo} style={{ width: '200px', height: 'auto' }} alt="MH Logo" />
                </div>
                <div style={{ display: 'flex', alignItems: 'center', paddingRight: '50px', gap: '15px' }}>
                    <CustomGreenButton width="140px" firstText="Get In Touch" secondText="Get In Touch" handleClick={handleOpen} />
                </div>
            </div>
            <EmailModal
                open={isModalOpen}
                handleClose={handleClose}
                handleSendEmail={handleSendEmail}
            />
            <Snackbar
                open={openSnackbar}
                autoHideDuration={3000}
                onClose={handleSnackbarClose}
            >
                <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </div>
    )
}

export default IntroHeader;

